import { Injectable } from '@angular/core'
import { ApiService } from './api.service'
import { config } from '../config/config'

import { RequestOptions } from '@angular/http'

import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/catch'
import 'rxjs/add/operator/map'

import { IEventRequestData } from '../models/event-form.model'
import { Event } from '../models/event.model'
import { Comment, ICommentRequestData } from '../models/comment.model'

@Injectable()
export class EventsService {

  constructor (private api: ApiService) {}

  async getAll (): Promise<Event[]> {
    const data = await this.api.get(`${config.api.url}/api/events`)
    return data.map(el => new Event().cast(el))
  }

  async getById (id): Promise<Event> {
    const data = await this.api.get(`${config.api.url}/api/events/${id}`)
    return new Event().cast(data)
  }

  async find (options): Promise<Event[]> {
    let query = `${config.api.url}/api/events?`

    if (options.type) query += `type=${options.type}&`
    if (options.from) query += `from=${options.from}&`
    if (options.to) query += `to=${options.to}&`
    if (options.groupId) query += `groupId=${options.groupId}&`
    if (options.search) query += `search=${encodeURIComponent(options.search)}&`

    const url = query.substring(0, query.length - 1)

    const data = await this.api.get(url)
    return data.map(el => new Event().cast(el))
  }

  async put (form: IEventRequestData): Promise<Event> {
    const data = await this.api.put(`${config.api.url}/api/events/${form.id}`, form)
    return new Event().cast(data)
  }

  async post (form: IEventRequestData): Promise<Event> {
    const data = await this.api.post(`${config.api.url}/api/events`, form)
    return new Event().cast(data)
  }

  delete (eventId: string): Promise<Object> {
    return this.api.delete(`${config.api.url}/api/events/${eventId}`)
  }

  async postComment (commentData: ICommentRequestData): Promise<Comment> {
    const data = await this.api.post(`${config.api.url}/api/events/${commentData.eventId}/comments`, commentData)
    return new Comment().cast(data)
  }

  async putComment (commentData: ICommentRequestData): Promise<Comment> {
    const data = await this.api.put(`${config.api.url}/api/events/${commentData.eventId}/comments/${commentData.id}`, commentData)
    return new Comment().cast(data)
  }

  deleteComment (eventId: string, commentId: string): Promise<Object> {
    return this.api.delete(`${config.api.url}/api/events/${eventId}/comments/${commentId}`)
  }

  async getCoordinates (event: Event): Promise<Object> {
    const address = `${event.address} ${event.zipcode} ${event.city} ${event.country}`

    const request = address && address.trim() !== ''
      ? await this.api.get(`${config.googleMap.url}/geocode/json?address=${address}`, new RequestOptions({ withCredentials: false }) )
        .catch(() => null)
      : null

    return request && request.status === 'OK' ? request.results[0].geometry.location : { lon: '', lat: '' }
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/services/events.service.ts